import Loader from 'apollo-react/components/Loader';
import _ from 'lodash';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MasterSetupTableActions from './MasterSetupTableActions';
import NavigateLinkCell from './NavigateLinkCell';
import SubTitle from './SubTitle';
import WorkflowMasterSetupTableActions from './WorkflowMasterSetupTableActions';
import { fetchUserHasManageRights, setParameters } from '../../actions/MasterSetupPageActions';
import DefaultPageLayout from '../../components/DefaultPageLayout';
import SavedSearchesTable from '../../components/SavedSearchesTable';
import { ENTITY_NAMES } from '../../constants/MasterSetupConstants';
import { POWERBI_ENTITY_NAME } from '../../constants/PowerBIConstants';
import { ENTITY_DISPLAY, WORKFLOW_MASTER_SETUP_PAGE } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  getEntityName,
  getIsLoading,
  getSearchName,
} from '../../selectors/MasterSetupPageSelectors';
import { getPagePathname } from '../../utils/childrenWindowsUtils';
import { getPowerBIExtraColumns } from '../../utils/powerBIUtils';
import WorkflowNavigateLinkCell from '../FindPage/NavigateLinkCell';

const MasterSetupPage = ({ location }) => {
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const entityName = useSelector(getEntityName);
  const searchName = useSelector(getSearchName);
  const isLoading = useSelector(getIsLoading);

  const [selectedReports, setSelectedReports] = useState([]);

  const route = getPagePathname();
  const isWorkflow = route === WORKFLOW_MASTER_SETUP_PAGE;
  const isPowerBIActionsEnabled = entityName === POWERBI_ENTITY_NAME;
  const isSubmissionCode = entityName === ENTITY_NAMES.SUBMISSION_CODE;

  const pageTitle = translateString(entityName);

  const MasterSetupTableActionsComponent = () =>
    isWorkflow ? (
      <WorkflowMasterSetupTableActions />
    ) : (
      <MasterSetupTableActions
        entityName={entityName}
        selectedReports={selectedReports}
        setSelectedReports={setSelectedReports}
      />
    );

  useEffect(() => {
    const { entityName, searchName } = qs.parse(location.search);

    dispatch(setParameters(entityName, searchName));
    dispatch(fetchUserHasManageRights(entityName));
  }, [dispatch, location.search]);

  useEffect(() => {
    document.title = pageTitle || 'Master Setup';
  }, [pageTitle]);

  useEffect(() => {
    sessionStorage.setItem('backButtonURL', location.pathname + location.search);
  }, [location]);

  const powerBIExtraColumns = getPowerBIExtraColumns(selectedReports, setSelectedReports);

  if (_.isNil(entityName)) {
    return (
      <DefaultPageLayout>{translateString('Please provide an entity name.')}</DefaultPageLayout>
    );
  }

  return (
    <DefaultPageLayout pageTitle={pageTitle} removeHeaderMargin>
      <SavedSearchesTable
        subTitle={isSubmissionCode ? <SubTitle /> : null}
        showSearchSelector={!isPowerBIActionsEnabled}
        customCell={
          isWorkflow ? WorkflowNavigateLinkCell.forUrl(ENTITY_DISPLAY) : NavigateLinkCell.fromColumn
        }
        entityName={entityName}
        enableSorting
        initialSearchName={searchName}
        rowsPerPageOptions={[10, 25, 50]}
        tableActions={MasterSetupTableActionsComponent}
        title={translateString('Records')}
        extraColumns={isPowerBIActionsEnabled ? powerBIExtraColumns : []}
      />
      {isLoading && <Loader />}
    </DefaultPageLayout>
  );
};

export default MasterSetupPage;
